import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const MAX_YEARS = 5

function YearsInUse({ years }) {
  const { t } = useTranslation()

  const text = useMemo(() => `${t('machine.years_in_use')} (${years})`, [years])
  const progress = useMemo(() => {
    if (years >= MAX_YEARS) return 100

    return (years * 100) / MAX_YEARS
  }, [years])

  return (
    <div className="years-in-use">
      <div className="years-in-use__progress" style={{ width: `${progress}%` }} />
      <div className="years-in-use__text">{text}</div>
    </div>
  )
}

YearsInUse.propTypes = {
  years: PropTypes.number.isRequired
}

export default memo(YearsInUse)
